module.exports = __webpack_public_path__ + "img/energy-disabled.5a2bc71e.png";